import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ExternalLinksService } from '@service/external-links.service';
import { ZoneConfigurationService } from '@service/zone-configuration.service';
import customProtocolCheck from 'custom-protocol-check';
import { combineLatest, timer } from 'rxjs';
import { ShareZoneConnectionToOtherAppService } from '../../../../../services/app-v5/share-zone-connection-to-other-app.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DesktopAppInstallerService, DesktopDeviceType } from '@service/app-v5/desktop-app-installer.service';




@Component({
    selector: 'tun-settings-desktop-app-panel',
    templateUrl: './settings-desktop-app-panel.component.html',
    styleUrls: ['./settings-desktop-app-panel.component.scss'],
    standalone: false
})
export class SettingsDesktopAppPanelComponent {

  @Output() back = new EventEmitter<void>();


  public get desktopDeviceType(){
    return this.desktopAppInstallerService.desktopDeviceType;
  }
  public DesktopDeviceType = DesktopDeviceType;

  constructor(
    private translateService: TranslateService,
    private zoneConfigurationService: ZoneConfigurationService,
    private externalLinksService: ExternalLinksService,
    private shareDesktopAppService: ShareZoneConnectionToOtherAppService,
    private desktopAppInstallerService: DesktopAppInstallerService
  ) {

  }

  onBack(){
    this.back.emit();
  }

  onDownload(){
    this.desktopAppInstallerService.downloadDesktopApp();
  }


  public get playerNotFound(){
    return this.shareDesktopAppService.playerNotFound;
  }

  public onStartDesktop(){
    this.shareDesktopAppService.openZoneInDesktopApp();


  }

  public onConnectZone(){

  }
}
